export default "__VITE_ASSET__C4UJpnOG__"